import React from 'react';
import { Dialog, DialogActions, DialogContent, DialogTitle, Button, Grid, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { getUnitById } from '../../utils/Enums';

import { formatMoney } from '../../utils/currency';
const ViewSupplyModal = ({ open, onClose, supply }) => {
  const { t } = useTranslation();

  if (!supply) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>{t('view_supply')}</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>
          <Grid item xs={6}>
            <Typography variant="subtitle1">{t('name')}:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{supply.name || 'N/A'}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">{t('iva')}:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{supply.iva || 'N/A'}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">{t('unit')}:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{getUnitById(supply.unit).label || 'N/A'}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">{t('stock')}:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{supply.countsStock ? (supply.stock ?? 'N/A') : '-'}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">{t('minimum_stock')}:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{supply.countsStock ? (supply.minimumStock ?? 'N/A') : '-'}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">{t('suggested_stock')}:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{supply.countsStock ? (supply.suggestedStock ?? 'N/A') : '-'}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">{t('uses_lot')}:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{supply.usesLot ? t('yes') : t('no')}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">{t('counts_stock')}:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{supply.countsStock ? t('yes') : t('no')}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">{t('price')}:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{supply.price ? formatMoney(supply.price, supply.costCurrency) : 'N/A'}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">{t('conversion_factor')}:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{supply.conversionFactor || 'N/A'}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">{t('primary_supplier')}:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{supply.primarySupplier.name || 'N/A'}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">{t('secondary_supplier')}:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{supply.secondarySupplier?.name || 'N/A'}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">{t('notes')}:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{supply.notes || 'N/A'}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">{t('alternative')}:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{supply.alternative || 'N/A'}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">{t('category')}:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{supply.category.name || 'N/A'}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">{t('sub_category')}:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{supply.subCategory.name || 'N/A'}</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="subtitle1">{t('presentation_quantity')}:</Typography>
          </Grid>
          <Grid item xs={6}>
            <Typography variant="body1">{supply.presentationQuantity || 'N/A'}</Typography>
          </Grid>
        </Grid>
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose}>{t('close')}</Button>
      </DialogActions>
    </Dialog>
  );
};

export default ViewSupplyModal;
